import { jsx } from 'react/jsx-runtime';
import { useTsrQueryClient } from './internal/use-tsr-query-client.esm.mjs';
import { initHooksContainer, initQueryClient } from './internal/create-hooks.esm.mjs';
import { TsRestInnerProvider } from './internal/provider-inner.esm.mjs';

const initTsrReactQuery = (contract, clientOptions) => {
    return {
        ReactQueryProvider: function ({ children }) {
            return (jsx(TsRestInnerProvider, { contract: contract, clientOptions: clientOptions, children: children }));
        },
        ...initHooksContainer(contract, clientOptions),
        useQueryClient: (useTsrQueryClient),
        initQueryClient: (queryClient) => {
            return initQueryClient(contract, clientOptions, queryClient);
        },
    };
};

export { initTsrReactQuery };
